export const TYPES = {
    SET_PRODUCT: 'SET_PRODUCT'
}

const newProductReducer = (state, action) => {
    switch (action.type){
        case TYPES.SET_PRODUCT:
            return action.payload;
        default:
            throw new Error("Not Supported Action Type!");
    }
}

export default newProductReducer;